module.exports = __webpack_public_path__ + "img/01.693c1408.jpg";